export function getBattery() {
  if(navigator?.getBattery){
    return navigator?.getBattery?.()?.then(function (battery) {
      return battery?.charging;
    });
  }
  return Promise.resolve(false);
  
}
